<template>
  <div class="cart-index">
    <TopNavbar :title="'Order History'" :bgColor="'bg-red'" />
    <div class="is-empty" v-if="requested && isEmpty">This order dosen't exist</div>
    <div v-if="requested && !isEmpty" class="main">
      <div v-for="(item,index) in orderList" :key="index" class="order-list-card">
        <div class="card-body" @click="viewDetail(item.id)">
          <div class="flex flex-center justify-between">
            <div>Order No. : </div>
            <div>{{item.ordersn}}</div>
          </div>
          <div class="flex flex-center justify-between card-line">
            <div>Date Time : </div>
            <div>{{item.dateline}}</div>
          </div>
          <div class="flex flex-center justify-between">
            <div><span v-if="item.is_takeaway==0">[Dine  In]</span>{{item.store_name}}</div>
            <div class="cartd-status">
              <span v-if="item.ispay == 0" class="ispay_yellow">{{ ispayList[item.ispay] }}</span>
              <span v-if="item.ispay == 1" class="ispay_green">{{ ispayList[item.ispay] }}</span>
              <span v-if="item.ispay == 2" class="ispay_yellow">{{ ispayList[item.ispay] }}</span>
              <span v-if="item.ispay == 3" class="ispay_red">{{ ispayList[item.ispay] }}</span>
            </div>
          </div>
          <div v-if="item.is_takeaway==1" class="flex flex-center justify-between card-line order-red-weight">
            <div>Contact Info: </div>
            <div>{{item.receiver_name}} ({{item.receiver_phone}})</div>
          </div>
          <div v-if="item.is_takeaway==0" class="flex flex-center justify-between card-line order-red-weight">
            <div>Table No.: </div>
            <div>{{item.tables_name}}</div>
          </div>
          <div v-if="item.is_takeaway==0" class="flex flex-center justify-between">
            <div>Quantity. : </div>
            <div>x{{item.totalnum}}</div>
          </div>
          <div class="flex flex-center justify-between">
            <div>Total Amount : <span class="order-red-weight">RM {{item.totalprice}}</span></div>
            <div>
              <span v-if="item.status==0" class="order-detail order-unconfirm-button" @click="viewDetail(item.id)">Unconfirm</span>
              <span v-if="item.status==1" class="order-detail order-confirm-button" @click="viewDetail(item.id)">Confirmed</span>
              <span v-if="item.status==3" class="order-detail order-complete-button" @click="viewDetail(item.id)">Completed</span>
              <span v-if="item.status==-1" class="order-detail order-cancel-button" @click="viewDetail(item.id)">Cancelled</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import TopNavbar from '../../components/common/TopNavbar.vue'
import { getHistoryList } from '@/api/api'
import homelogo from "@/assets/fastorder.logo.png"
import { cartMixin } from '@/mixins/cartMixin'

export default {
  components: {
    TopNavbar
  },
  props: {
  },
  data () {
    return {
      requested: false,
      isEmpty: false,
      homelogo: homelogo,
      orderLength: 0,
      orderList: [],
      ispayList: ['Unpaid', 'Paid', 'Pending Refund', 'Refunded', 'Refund Failed'],
    }
  },
  mixins: [cartMixin],
  created () {
    this.initPageData()
  },
  methods: {
    initPageData () {
      const whereJson = this.getUrlParams({ 'do': 'getHistoryList' })
      getHistoryList('/app/index.php', whereJson).then(res => {
        this.requested = true
        this.isEmpty = false
        const { from_user, has_sso_login, order_list } = res.data
        this.orderLength = order_list.length
        this.orderList = order_list
      }).catch((error) => {
        this.requested = true
        this.isEmpty = true
      })
    },
    viewDetail (int_order_id) {
      const url = {        path: '/order', query: {
          i: 2,
          mode: 1,
          append: 1,
          c: 'entry',
          do: 'orderdetail',
          m: 'weisrc_dish',
          op: 'viewdetail',
          orderid: int_order_id,
          h5api: 'on',
          year: '2020',
          pt: 'wx2h5'
        }      }
      this.$router.push(url)

    }
  }
}
</script>
<style lang="less" scoped>
@import url('../../assets/css/common.less');
.order-red-weight {
  color: #ee2d24;
  font-weight: bold;
}

.title {
  font-weight: 700;
}
.order-detail-navbar {
  width: 100%;
  display: flex;
  align-items: center;
  .home-logo {
    width: 20px;
    height: 20px;
    img {
      width: 100%;
    }
  }
}
.onHome {
  padding: 4px 0;
  flex: 1;
  text-align: center;
}
.is-empty {
  padding: 5px;
  color: #666;
}
.main {
  margin-top: 35px;
  font-size: 14px;
  background-color: #eee;
  .ispay_red {
    color: @red;
  }
  .ispay_green {
    color: @green;
  }
  .ispay_yellow {
    color: #ffba19;
  }

  &:last-child {
    border: 0;
  }
  .order-list-card {
    padding: 8px;
    background: white;
    margin-bottom: 24px;
    .card-body {
      // border-bottom: 1px solid #cccccc52;
      margin: 0px 0 0px 0;
      padding: 0px 0 10px 0;
      line-height: 22px;
      .cartd-status {
        font-weight: bold;
      }
      .card-line {
        border-bottom: 1px solid #eee;
        padding-bottom: 8px;
        margin-bottom: 8px;
      }

      .order-detail {
        font-weight: bold;
        color: #3d3d3d;
      }
      .order-unconfirm-button {
        border: 1px solid #ffba19;
        border-radius: 3px;
        padding: 0px 5px;
        background-color: #ffba19;
        color: white;
        font-weight: bold;
      }
      .order-confirm-button {
        border: 1px solid #28a267;
        border-radius: 3px;
        padding: 0px 5px;
        background-color: #28a267;
        color: white;
        font-weight: bold;
      }
      .order-complete-button {
        border: 1px solid #5cb85c;
        border-radius: 3px;
        padding: 0px 5px;
        background-color: #5cb85c;
        color: white;
        font-weight: bold;
      }
      .order-cancel-button {
        border: 1px solid #ef4437;
        border-radius: 3px;
        padding: 0px 5px;
        background-color: #ef4437;
        color: white;
        font-weight: bold;
      }
    }
  }
}
</style>

